<div fxLayout="column" fxLayoutGap="16px">

  <mat-list>
    <ng-container *ngFor="let weekDay of weekDays; let last = last">
      <mat-list-item [ngClass]="workingHours.get(weekDay.key).isEditable? 'expanded': ''">

        <span fxFlex="10%">
          {{weekDay.value | translate}}
        </span>

        <div fxFlex fxLayout="row" fxLayoutAlign="space-around center" *ngIf="workingHours.get(weekDay.key).isEditable">
          <mat-form-field fxFlex="40">
            <mat-select [(ngModel)]="workingHours.get(weekDay.key).startTime" placeholder="{{'date.from' |translate}}">
              <mat-option *ngFor="let hour of hourDropdown" [value]="hour">
                {{ hour | timeLocalization }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field fxFlex="40">
            <mat-select [(ngModel)]="workingHours.get(weekDay.key).endTime" placeholder="{{'date.to' |translate}}">
              <mat-option *ngFor="let hour of hourDropdown" [value]="hour">
                {{ hour | timeLocalization }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div fxFlex fxLayout="row" fxLayoutAlign="center center" *ngIf="!workingHours.get(weekDay.key).isEditable">
          {{workingHours.get(weekDay.key) | workingHourText}}
        </div>

        <div fxFlex="10%" fxLayoutAlign="end">
          <mat-icon class="cursor-pointer" *ngIf="canEdit && !workingHours.get(weekDay.key).isEditable"
            (click)="toggleEditable(workingHours.get(weekDay.key))">mode_edit
          </mat-icon>
          <mat-icon class="cursor-pointer"
            *ngIf="workingHours.get(weekDay.key).isEditable && !workingHours.get(weekDay.key).isFree()"
            (click)="freeDay(workingHours.get(weekDay.key))" matTooltip="{{'working_hours.free' | translate}}">delete
          </mat-icon>
          <!-- <mat-icon class="cursor-pointer" *ngIf="workingHours.get(weekDay.key).isEditable"
                   (click)="toggleEditable(workingHours.get(weekDay.key))">cancel
          </mat-icon> -->
        </div>
      </mat-list-item>
      <mat-divider *ngIf="!last"></mat-divider>
    </ng-container>
  </mat-list>

  <button *ngIf="editMode" mat-raised-button (click)="save(); resetEditModes()" color="primary">
    {{'global.save' | translate}}
  </button>

  <button *ngIf="editMode" mat-button (click)="cancel()">
    {{'global.cancel' | translate}}
  </button>

</div>

